const isViewerPlugin = (pluginOrConfig) => {
  return "config" in pluginOrConfig;
};
const isViewerPluginOptions = (pluginOrConfig) => {
  return !("config" in pluginOrConfig);
};
export {
  isViewerPlugin,
  isViewerPluginOptions
};
//# sourceMappingURL=is-viewer-plugin.js.map
